export default "__VITE_ASSET__B4hXEp4m__"